export default __webpack_public_path__ + "static/media/logo.fd687442.png";